import { render, staticRenderFns } from "./IntroductionGreetingPage.vue?vue&type=template&id=2093acaa&"
import script from "./IntroductionGreetingPage.vue?vue&type=script&lang=js&"
export * from "./IntroductionGreetingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports